import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    theme: {
        themes: {
            light: {
                primary:    "#1B4188",
                secondary:  "#ff6400",
                accent:     "#01579B", // Revisado
                error:      "#B71C1C", // Revisado
                warning:    "#ff9800",
                info:       "#2196f3",
                success:    "#4caf50",
                selected :  "#C8E6C9",
                bgDinamic: "#ffffff",
            },
            dark: {
                primary:    '#0D47A1',
                secondary:  "#c43100",
                accent:     "#4FC3F7", // Revisado
                error:      "#E57373", // Revisado
                warning:    "#E65100",
                info:       "#0D47A1",
                success:    "#1B5E20",
                selected :  "#1B5E20",
                bgDinamic: "#1f1f1f",
            },
        },
    },
}

export default new Vuetify(opts)